import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=4199b9c1&scoped=true"
import script from "./PageBreadcrumbs.js?vue&type=script&lang=js&external"
export * from "./PageBreadcrumbs.js?vue&type=script&lang=js&external"
import style0 from "./PageBreadcrumbs.scss?vue&type=style&index=0&id=4199b9c1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199b9c1",
  null
  
)

export default component.exports